import React, { useState } from 'react'
import { CommonSlider } from '@/components/common'
import { SubSection, StyledDemoGrid, DemoComponent } from '../styled.jsx'

export const SliderSection = () => {
  const [distance, setDistance] = useState(0.5)
  const [distanceRange, setDistanceRange] = useState([1, 25])
  const [time, setTime] = useState('08:00 AM')
  const [timeRange, setTimeRange] = useState(['06:00 AM', '10:00 AM'])

  return (
    <>
      <SubSection
        title='Distance Slider'
        description='Single and range distances'
      >
        <StyledDemoGrid sx={{ flexDirection: 'column', alignItems: 'stretch' }}>
          <DemoComponent
            label='Single value'
            component={
              <CommonSlider
                id='common-distance-slider'
                variant='distance'
                value={distance}
                onChange={setDistance}
              />
            }
            value={`${distance} mi`}
          />
          <DemoComponent
            label='Range'
            component={
              <CommonSlider
                id='common-distance-range'
                variant='distance'
                title='Distance Range'
                isRange={true}
                value={distanceRange}
                onChange={setDistanceRange}
              />
            }
            value={`${distanceRange[0]} - ${distanceRange[1]} mi`}
          />
        </StyledDemoGrid>
      </SubSection>

      <SubSection
        title='Time Slider'
        description='Single and range time selections'
      >
        <StyledDemoGrid sx={{ flexDirection: 'column', alignItems: 'stretch' }}>
          <DemoComponent
            label='Single value'
            component={
              <CommonSlider
                id='common-times-slider'
                variant='time'
                isRange={false}
                value={time}
                title='Select a Time'
                onChange={setTime}
              />
            }
            value={time}
          />
          <DemoComponent
            label='Range'
            component={
              <CommonSlider
                id='common-times-range'
                variant='time'
                isRange={true}
                value={timeRange}
                onChange={setTimeRange}
              />
            }
            value={`${timeRange[0]} - ${timeRange[1]}`}
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
